// WarRoom presentation config — persona filters + shared style maps.

export const SEVERITY_COLORS = {
  P1: "border-rose-500/40 text-rose-300 bg-rose-500/5",
  P2: "border-amber-500/40 text-amber-300 bg-amber-500/5",
  P3: "border-sky-500/40 text-sky-300 bg-sky-500/5",
  P4: "border-zinc-500/40 text-zinc-300 bg-zinc-500/5",
};

export const STATUS_STYLE = {
  pending_analysis: "text-zinc-400",
  analyzing: "text-blue-300",
  awaiting_approval: "text-amber-300",
  approved: "text-emerald-300",
  rejected: "text-rose-300",
  modified: "text-violet-300",
};

export const NAV_ANCHORS = [
  ["sec-flow", "Flow"],
  ["sec-triage", "Triage"],
  ["sec-summary", "Summary"],
  ["sec-rootcause", "Root cause"],
  ["sec-agents", "Agents"],
  ["sec-consensus", "Consensus"],
  ["sec-accountability", "Accountability"],
  ["sec-final-plan", "Final plan"],
  ["sec-runbook", "Runbook"],
  ["sec-approval", "Approval"],
  ["sec-feedback", "Feedback"],
  ["sec-audit", "Audit"],
];

// Persona section maps — pure presentation filter. Each persona lists the
// section keys it wants to show. Full View shows every section.
export const PERSONA_SECTIONS = {
  fullView: null, // null = show everything
  leadership: new Set([
    "sec-summary",
    "sec-cre-score",
    "sec-rootcause",
    "sec-final-plan",
    "sec-approval",
    "sec-audit",
  ]),
  operations: new Set([
    "sec-flow",
    "sec-triage",
    "sec-summary",
    "sec-cre-score",
    "sec-incident",
    "sec-rootcause",
    "sec-agents",
    "sec-consensus",
    "sec-accountability",
    "sec-final-plan",
    "sec-runbook",
    "sec-approval",
    "sec-feedback",
    "sec-mttr",
    "sec-audit",
  ]),
};

export const NAV_ANCHORS_BY_PERSONA = {
  fullView: NAV_ANCHORS,
  leadership: [
    ["sec-summary", "Summary"],
    ["sec-rootcause", "Root cause"],
    ["sec-cre-score", "CRE Confidence"],
    ["sec-final-plan", "Action Plan"],
    ["sec-approval", "Approval"],
    ["sec-audit", "Audit"],
  ],
  operations: NAV_ANCHORS,
};

export function showSection(persona, key) {
  const allow = PERSONA_SECTIONS[persona];
  if (!allow) return true; // Full View
  return allow.has(key);
}
